import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  isAppActive: BehaviorSubject<boolean> = new BehaviorSubject(true)

  constructor() {}
}
